module.exports = __webpack_public_path__ + "static/media/footerimg.e014930d.jpg";